/**
 * Utilities for working with lecture files
 */

import { LECTURE_ID_REGEX } from './config.js';

/**
 * Check if file is an audio lecture
 * @param {Object} file - File object
 * @returns {boolean}
 */
export function isAudioLecture(file) {
	if (!file) return false;
	
	const filePath = (file.p || file.path || '').toUpperCase();
	const fileName = (file.n || file.name || '').toUpperCase();
	const fullPath = `${filePath}/${fileName}`;
	
	// Check if path contains /AUDIO and /Lecture or /LECTURE
	const hasAudio = /\/AUDIO/.test(fullPath);
	const hasLecture = /\/LECTURE/.test(fullPath);
	
	return hasAudio && hasLecture;
}

/**
 * Extract lecture name from file (full filename without extension)
 * @param {Object} file - File object
 * @returns {string|null} - Lecture name (e.g., "5205C20A – 7ACC-38 – Control") or null
 */
export function extractLectureName(file) {
	if (!file) return null;
	
	const fileName = file.n || file.name || '';
	if (!fileName) return null;
	
	// Remove .mp3 extension if present
	const lectureName = fileName.replace(/\.mp3$/i, '').trim();
	return lectureName || null;
}

/**
 * Extract lecture ID from file path/name (for backward compatibility)
 * @param {Object} file - File object
 * @returns {string|null} - Lecture ID or null
 */
export function extractLectureId(file) {
	if (!file) return null;
	
	const filePath = file.p || file.path || '';
	const fileName = file.n || file.name || '';
	const fullPath = `${filePath}/${fileName}`;
	
	// Try to match lecture ID pattern
	const match = fullPath.match(LECTURE_ID_REGEX);
	return match ? match[0] : null;
}

/**
 * Extract lecture name from current file (helper for language switching)
 * @returns {string|null}
 */
export function extractLectureNameFromCurrentFile() {
	// This will be called from player-core.js context
	// We need to get current file from player-core
	if (typeof window !== 'undefined' && window.getCurrentAudioFile) {
		const file = window.getCurrentAudioFile();
		return file ? extractLectureName(file) : null;
	}
	return null;
}

